// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"63e110bc","521":"63e110bc"}[chunkId] + ".chunk.css";
};